/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The SectionEditForm model module.
   * @module textbook/model/SectionEditForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>SectionEditForm</code>.
   * @alias module:textbook/model/SectionEditForm
   * @class
   * @param title {String} 标题
   */
  var exports = function(title) {
    var _this = this;

    _this['title'] = title;




  };

  /**
   * Constructs a <code>SectionEditForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/SectionEditForm} obj Optional instance to populate.
   * @return {module:textbook/model/SectionEditForm} The populated <code>SectionEditForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'directions')) {
        obj['directions'] = ApiClient.convertToType(data['directions'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'targetPoint')) {
        obj['targetPoint'] = ApiClient.convertToType(data['targetPoint'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'seenToc')) {
        obj['seenToc'] = ApiClient.convertToType(data['seenToc'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'filePath')) {
        obj['filePath'] = ApiClient.convertToType(data['filePath'], 'String');
      }
    }
    return obj;
  }

  /**
   * 标题
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 题目指令
   * @member {String} directions
   */
  exports.prototype['directions'] = undefined;
  /**
   * 课程总积分
   * @member {Integer} targetPoint
   */
  exports.prototype['targetPoint'] = undefined;
  /**
   * 在目录中是否可见
   * @member {Boolean} seenToc
   */
  exports.prototype['seenToc'] = undefined;
  /**
   * html路径
   * @member {String} filePath
   */
  exports.prototype['filePath'] = undefined;



  export default exports;
;


